// extracted by mini-css-extract-plugin
export var footer__content = "Footer-module--footer__content--rwl8l";
export var copyright__content = "Footer-module--copyright__content--3zKcE";
export var footer = "Footer-module--footer--31LQy";
export var footer__brand = "Footer-module--footer__brand--2i0x6";
export var footer__brand__title = "Footer-module--footer__brand__title--1Gj6G";
export var footer__brand__subtitle = "Footer-module--footer__brand__subtitle--zA1Xs";
export var footer__connect_icons = "Footer-module--footer__connect_icons--1Yb10";
export var footer__connect_icons__icon = "Footer-module--footer__connect_icons__icon--2iRyO";
export var copyright = "Footer-module--copyright--2Iyp5";